var elem = document.querySelector('.banner_slider_desktop');
var flkty = new Flickity(elem, {
  // options
  cellAlign: 'left',
  contain: true,
  prevNextButtons: true,
  pageDots: false,
  wrapAround: true,
  autoPlay: 5500,
  pauseAutoPlayOnHover: false,
  //imagesLoaded: true,
  // fade: true,
  //lazyLoad: 2,
});

var elem_m = document.querySelector('.banner_slider_mobile');
var flkty_m = new Flickity(elem_m, {
  // options
  cellAlign: 'left',
  contain: true,
  prevNextButtons: false,
  pageDots: false,
  wrapAround: true,
  autoPlay: 5500,
  pauseAutoPlayOnHover: false,
  // imagesLoaded: true,
});

var slider = document.querySelector('.banner_slider_desktop .flickity-slider');
  slider.childNodes.forEach(function(node) {
    node.classList.remove('hidden_loading');
  }
  );

  var slider = document.querySelector('.banner_slider_mobile .flickity-slider');
  slider.childNodes.forEach(function(node) {
    node.classList.remove('hidden_loading');
  }
  );

  setInterval(() => {flkty.resize()}, 1);
  setInterval(() => {flkty_m.resize()}, 1);


/*window.addEventListener('load', function () {
  var slider = document.querySelector('.banner_slider_desktop .flickity-slider');
  slider.childNodes.forEach(function(node) {
    node.classList.remove('hidden_loading');
  }
  );

  var slider = document.querySelector('.banner_slider_mobile .flickity-slider');
  slider.childNodes.forEach(function(node) {
    node.classList.remove('hidden_loading');
  }
  );

  //elem_m.classList.remove('hidden_loading');
  //placeholder_desktop.removeChild(placeholder_desktop.firstChild);
  //placeholder_mobile.removeChild(placeholder_mobile.firstChild);
  setInterval(() => {flkty.resize()}, 1);
  setInterval(() => {flkty_m.resize()}, 1);
});*/